export const onlyNumber = (event) => {
  event = event ? event : window.event;
  const regNum = /\d/g;

  if (regNum.test(Number(event.key))) {
    return true;
  } else {
    if (event.key === "." || event.key === ",") {
      const reg = /,|\./g;
      return !reg.test(event.target.value) ? true : event.preventDefault();
    }
    if (
      (event.ctrlKey === true || event.metaKey === true) &&
      (event.key === "c" ||
        event.key === "v" ||
        event.key === "x" ||
        event.key === "r" ||
        event.key === "с" ||
        event.key === "м" ||
        event.key === "ч")
    ) {
      return true;
    }
    if (
      (event.shiftKey === true || event.shiftKey === false) &&
      (event.key === "ArrowLeft" || event.key === "ArrowRight")
    ) {
      return true;
    }
    if (event.key === "Enter") {
      this.$emit("enter");
      return true;
    }
    if (event.key === "Backspace") {
      return true;
    }
    if (event.key === "Delete") {
      return true;
    }
    if (event.key === "Tab") {
      return true;
    }
    if (event.key === "-") {
      return true;
    }

    event.preventDefault();
  }
};
